import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';

import {
  getAmountField,
  getBudgetAmountField,
  getMedicalRiskField,
  getServicesField,
  getWarrantyField
} from './fields';
import ServiceService from '../../../services/service-service';
import RiskService from '../../../services/risk-service';
import WarrantyService from '../../../services/warranty-service';
import { useLoadingBar } from '../../../libraries/contexts';

import { SERVICE_FORM_TITLE } from '../../../libraries/texts';
import { MINIMUM_SELECTION_SERVICE, MAXIMUM_SELECTION_SERVICE } from '../../../libraries/constants';

import { service as styles } from '../styles';

const ServiceForm = props => {
  const { values, classes, handleBlur, errors, touched, setFieldValue, setFieldTouched } = props;
  const [guaranteeTypes, updateGuaranteeTypes] = useState([]);
  const [loading, setLoading] = useLoadingBar();
  const [risks, updateMedicalRisks] = useState([]);
  const [services, updateServices] = useState([]);

  const getRequests = async () => {
    setLoading({ principalLoading: true });
    const services = await ServiceService.getAll();
    await updateServices(services);
    const guaratees = await WarrantyService.getAll();
    await updateGuaranteeTypes(guaratees);
    const risks = await RiskService.getAll();
    await updateMedicalRisks(risks);
    await setLoading({ principalLoading: false });
  };

  const addNewService = () => {
    values.services.push({ key: values.services.length });
    setFieldValue('services', values.services);
  };
  const removeNewService = index => event => {
    values.services.splice(index, 1);
    setFieldValue('services', values.services);
  };

  const allowAddService = index => {
    const {
      services: { length }
    } = values;
    return length < MAXIMUM_SELECTION_SERVICE && length - 1 === index;
  };

  const allowRemoveService = () => values.services.length <= MINIMUM_SELECTION_SERVICE;

  useEffect(() => {
    getRequests();
  }, []);

  const fieldProps = {
    handleBlur,
    classes,
    touched,
    errors,
    values,
    setFieldValue,
    setFieldTouched,
    allowAddService,
    removeNewService,
    allowRemoveService,
    addNewService,
    services,
    risks,
    loading,
    guaranteeTypes
  };
  return (
    <Card className={classes.card}>
      <CardHeader title={SERVICE_FORM_TITLE} className={classes.cardTitle} />
      <CardContent className={classes.cardContent}>
        {values ? (
          <React.Fragment>
            {getWarrantyField({ ...fieldProps })}
            {getMedicalRiskField({ ...fieldProps })}
            <Divider />
            {getServicesField({ ...fieldProps })}
            <Divider />
            {getBudgetAmountField({ ...fieldProps })}
            {getAmountField({ ...fieldProps })}
          </React.Fragment>
        ) : (
          ''
        )}
      </CardContent>
    </Card>
  );
};

ServiceForm.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ServiceForm);
